<template>
  <v-card flat class="dialog-card">
    <v-toolbar flat light color="white">
      <v-toolbar-title>{{ $t('paymentPlan') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <payment-plan-rows :paymentPlan="paymentPlan"></payment-plan-rows>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import PaymentPlanRows from '../Tabs/PaymentPlan.vue'

  export default {
    props: ['paymentPlan'],
    components: {
      'payment-plan-rows': PaymentPlanRows
    }
  }
</script>
